import { render, staticRenderFns } from "./ApproveRemind.vue?vue&type=template&id=a17f6cae"
import script from "./ApproveRemind.vue?vue&type=script&lang=js"
export * from "./ApproveRemind.vue?vue&type=script&lang=js"
import style0 from "./ApproveRemind.vue?vue&type=style&index=0&id=a17f6cae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports